module.exports = __webpack_public_path__ + "static/media/part-return-slide-4.8229907d.jpg";